function openSamples()
{
   if(!localStorage.getItem('samples'))
  {

  localStorage.setItem('samples', 'true');
  }

  refreshAllSelections();
 
  if ($('#panelClass .collectionTitleWrap').is(':visible')) {
    $('#select_samples').prop('checked', true);
  } else {
    $('#surprise_me').prop('checked', true);  
  }

  $('.drawer__samples-selected').text(0);
}

function clsoSamples()
  {
  refreshAllSelections();
  $("#sample-popup").removeClass("showMeNow"); 
  
 }

function refreshAllSelections()
{
  $('div#panelClass input[type="checkbox"]').prop('checked',false);
   
  $('.cart-item.SampleProduct').each(function(item) {
    var id = $(this).data('id'); 
    $(id).prop('checked',true); 
  });
}


function decideAndProceed(){
const shopLocal0 = document.querySelector('#shopLocaleInput1').value;
  // let localHref = ;
  // if (localHref.includes('en-stage-new.eisenberg.com')) {
  //   localHref = 'en-stage-new.eisenberg.com';
  // }
  console.log('shopLocal0', shopLocal0);
let shopLocal = '';
  if (shopLocal0 != 'en-MC') {
    shopLocal = shopLocal0;
    console.log('shopLocal00', shopLocal);
  };
  if (shopLocal0 === 'fr-MC') {
    shopLocal = 'fr';
  } 
  if (shopLocal0 === 'de-MC') {
    shopLocal = 'de';
  } 
  if (shopLocal0 === 'ru-MC') {
    shopLocal = 'ru';
  } 
  if (shopLocal0 === 'zh-CN-MC') {
    shopLocal = 'zh';
  } 
  if (shopLocal0 === 'it-MC') {
    shopLocal = 'it';
  }

  if (shopLocal0.startsWith('zh-CN-') && shopLocal0 !== 'zh-CN-MC') {
      shopLocal = shopLocal0.replace('CN-', '');
}


  
  
  console.log('shopLocal000', shopLocal);
  console.log('decideAP');

  var total = $("div#sample-popup div#panelClass input[type=checkbox]:checked").length;

  console.log('total', total);
  
  if(total > 0)
  {  
    $(".bottomCheckout a.button-natural").css('pointer-events','none');
 
     var items1 = []; 
    $( 'div#sample-popup div#panelClass input[type=checkbox]:checked' ).each(function() {
    
      var addit = true;
      var idM = $(this).attr("id");idM = "#"+idM;
      $('.cart-item.SampleProduct').each(function(item) { 
      var id = $(this).data('id');  
      if(idM == id)
      {
        addit = false;
      } 
      });
    
      if(addit) {
        var obj = {};
        obj["quantity"] = 1;
        obj["id"] = $(this).data('variant');
        items1.push(obj);
      }
    });
    
    if(items1.length != 0) {
    
      if(items1.length == 1) { 
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: items1[0],
          dataType: 'json', 
          success: function (data) { 
          if (shopLocal.includes('zh') && !shopLocal.includes('zh-')) {
            window.parent.location.href=`/checkout/?locale=${shopLocal}-CN`;
            return;
          }
            if (shopLocal.includes('zh-')) {
              let parts = shopLocal.split("-");
parts.splice(1, 0, "cn");
let result = parts.join("-");
            window.parent.location.href=`/checkout/?locale=${result}`;
            return;
          }
            
            if (shopLocal === '') {
    window.parent.location.href = 'https://en-stage-new.eisenberg.com/checkout';
  } else {
            window.parent.location.href=`/${shopLocal}/checkout/?locale=${shopLocal}`;
            }
            },
          error:function(data){
            console.log(data);
          }
        });
      }else{ 
       
        $.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: { items: items1 },
          dataType: 'json',
          success: function(data) { 
      if (shopLocal.includes('zh') && !shopLocal.includes('zh-')) {
            window.parent.location.href=`/checkout/?locale=${shopLocal}-CN`;
            return;
          }
            if (shopLocal.includes('zh-')) {
              let parts = shopLocal.split("-");
parts.splice(1, 0, "cn");
let result = parts.join("-");
            window.parent.location.href=`/checkout/?locale=${result}`;
            return;
          }
            
             if (shopLocal === '') {
    window.parent.location.href = 'https://en-stage-new.eisenberg.com/checkout';
  } else {
            window.parent.location.href=`/${shopLocal}/checkout/?locale=${shopLocal}`;
            }
          },
          error:function(data){
            console.log(data);
          }
        });
      }
      
    } else {
      if (shopLocal.includes('zh') && !shopLocal.includes('zh-')) {
            window.parent.location.href=`/checkout/?locale=${shopLocal}-CN`;
            return;
          }
            if (shopLocal.includes('zh-')) {
              let parts = shopLocal.split("-");
parts.splice(1, 0, "cn");
let result = parts.join("-");
            window.parent.location.href=`/checkout/?locale=${result}`;
            return;
          }
       
            if (shopLocal === '') {
    window.parent.location.href = 'https://en-stage-new.eisenberg.com/checkout';
  } else {
            window.parent.location.href=`/${shopLocal}/checkout/?locale=${shopLocal}`;
            }
    }
    
  }else{
    if (shopLocal.includes('zh') && !shopLocal.includes('zh-')) {
            window.parent.location.href=`/checkout/?locale=${shopLocal}-CN`;
            return;
          }
            if (shopLocal.includes('zh-')) {
              let parts = shopLocal.split("-");
parts.splice(1, 0, "cn");
let result = parts.join("-");
            window.parent.location.href=`/checkout/?locale=${result}`;
            return;
          }
          
            if (shopLocal === '') {
    window.parent.location.href = 'https://en-stage-new.eisenberg.com/checkout';
  } else {
            window.parent.location.href=`/${shopLocal}/checkout/?locale=${shopLocal}`;
            }
  }   
} 



window.addEventListener('popstate', function (e) {
    var state = e.state;
    if (state !== null) {
        //load content with ajax
     
    }
});

function triggerClick() {
  var panel = document.getElementById("panelClass");
  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;

    $('div#panelClass input[type="checkbox"]').prop('checked',false);
  } else {
    panel.style.maxHeight = "1000px";
  }
}  

$("cart-remove-button").click(function(){
  if($('div#panelClass input[type="checkbox"]'))
    $('div#panelClass input[type="checkbox"]').prop('checked',false);
});

$('body').click(function(e){

  const click_target = $(e.target);

  if (click_target.prop('tagName') == 'BUTTON' && click_target.hasClass('accordionBTN')) {

    let panel = $(this).parent().find('.panel');

    if (panel.is(':visible')) {
      click_target.removeClass('drawer__info-bar_open');
      click_target.addClass('drawer__info-bar_closed');
      panel.slideUp();
    } else {
      click_target.addClass('drawer__info-bar_open');  
      click_target.removeClass('drawer__info-bar_closed');
      panel.slideDown();
    }

  } else if (click_target.prop('tagName') == 'DIV' && click_target.hasClass('button-natural_no')) {

    $('.bottomCheckout').addClass('loading-rotation');
    
    let note;

    if (innerWidth >= 744) {
     note = $('.drawer__notepc').val();
    }
    
    if (innerWidth <= 743) {
     note = $('.drawer__notepcmobile').val();
    }
    
    // if ($('.cart-item-product-of-month').length) {
    //   note = 'PRODUCT OF THE MONTH\n' + note;
    // }
    
    if ($('#surprise_me').is(':checked')) {
      note = 'SURPRISE-ME\n' + note;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {'note': note},
      dataType: 'json',
      success: function(result) {
        if (shopLocal.includes('zh') && !shopLocal.includes('zh-')) {
            window.parent.location.href=`/checkout/?locale=${shopLocal}-CN`;
            return;
          }
            if (shopLocal.includes('zh-')) {
              let parts = shopLocal.split("-");
parts.splice(1, 0, "cn");
let result = parts.join("-");
            window.parent.location.href=`/checkout/?locale=${result}`;
            return;
          }
            if (shopLocal === '') {
    window.parent.location.href = 'https://en-stage-new.eisenberg.com/checkout';
  } else {
            window.parent.location.href=`/${shopLocal}/checkout/?locale=${shopLocal}`;
            }
      }
    });

  } else if (click_target.prop('tagName') == 'DIV' && click_target.hasClass('button-natural_proceed')) {

    $('.bottomCheckout').addClass('loading-rotation');
    
    let note = $('.drawer__note').val();

    // if ($('.cart-item-product-of-month').length) {
    //   note = 'PRODUCT OF THE MONTH\n' + note;
    // }
    
    if ($('#surprise_me').is(':checked')) {
      note = 'SURPRISE-ME\n' + note;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {'note': note},
      dataType: 'json',
      success: function(result) {
         console.log('note11', note);
           // decideAndProceed();
     
      }
    });
  }
});

$('body').change(function(e){

  const click_target = $(e.target);

  if (click_target.attr('id') == 'surprise_me' && $('#surprise_me').is(':checked')) {
    
    $('#panelClass input')
      .prop('checked', false)
      .prop('disabled', true);

    $('#panelClass .collectionTitleWrap').hide();

     $('.drawer__samples-selected').text(0);

  } else if (click_target.attr('id') == 'select_samples' && $('#select_samples').is(':checked')) {

    $('#panelClass .collectionTitleWrap').show();
    $('#panelClass input').prop('disabled', false); 
  }

  if (click_target.prop('tagName') == 'INPUT' && click_target.attr('type') == 'checkbox' && click_target.hasClass('designSampleCheck')) {
    $('.drawer__samples-selected').text($('.designSampleCheck:checked').length);
  }
});


function messagePM() {
  if (innerWidth <= 743) {
  const barPc = document.querySelector('.drawer__note-wrapper.cForPc');
  const divMobile = document.querySelector('.mobile-messege__popUp');  
  const mobileTextArea = document.querySelector('.mobile-messege__popUp textarea');
  const buttonPopUpcart = document.querySelector('.buttonPopUpcart');
  const closePopUp = document.querySelector('.mobile-messege__popUp_close');
  const cForMobile = document.querySelector('.drawer__note-wrapper.cForMobile');
  const footerTotal = document.querySelector('.cart-drawer__footer .totals');  
    
  mobileTextArea.disabled = false;
  if (barPc) {
  barPc.remove();
  }
  divMobile.style.display = 'block';
  cForMobile.style.display = 'block';
  footerTotal.setAttribute('style', 'display: none !important;');

  const infoBarElement = document.querySelector('.drawer__info-bar_message');
  
  buttonPopUpcart.addEventListener('click', () => {
    divMobile.style.display = 'none';
    footerTotal.setAttribute('style', 'display: grid !important;');
    // infoBarElement.classList.add('drawer__info-bar_closed');
  });

  closePopUp.addEventListener('click', () => {
    divMobile.style.display = 'none';
    footerTotal.setAttribute('style', 'display: grid !important;');
    // infoBarElement.classList.add('drawer__info-bar_closed');
  });
  
  }
  
}


function clickOnSuprisme() {

const samplesInCart = document.querySelectorAll('cart-drawer-items .SampleProduct');
console.log('samplesInCart121', samplesInCart);

if (samplesInCart.length > 0) {
    var productIds = [];

    samplesInCart.forEach((sample) => {
        var idValue = sample.dataset.idv;
        productIds.push(idValue);
    });

    function updateCart(i) {
        if (i < productIds.length) {
            var updatesObject = {};
            updatesObject[productIds[i]] = 0;
            console.log('updatesObject', updatesObject);

            jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
                updates: updatesObject
            }).done(function() {
                updateCart(i + 1); // Переходим к следующему продукту после успешного обновления
            });
        } else {
      let refreshCart = document.querySelector('.refreshCart');
          setTimeout(() => {
                      
            refreshCart.click();
            },1000);
    }
    } 

    updateCart(0); // Начинаем с первого продукта
}

 
};